import {
  BasicButton,
  ButtonGroup,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
  PrimaryButton,
  Text,
} from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

type DisableOneIDFallbackModalProps = {
  show?: boolean;
  onClose: () => void;
  disableFallback: () => void;
};

export function DisableOneIDFallbackModal({
  show = false,
  onClose,
  disableFallback,
}: DisableOneIDFallbackModalProps) {
  const { t } = useTranslation();

  if (!show) {
    return null;
  }

  return (
    <Modal isOpen={show} testID="disable-oneid-fallback-modal">
      <Dialog width="560px">
        <DialogHeader onClose={onClose}>{t("Disable fallback?")}</DialogHeader>
        <DialogContent>
          <Text style="global/body-primary">
            {t(
              "By disabling this fallback and in accordance with applicable laws, you acknowledge that you will be responsible for providing another non-biometric identity verification method, and collecting any related necessary information if an applicant declines or cannot complete the biometric verification process. Please consult your legal counsel if you are uncertain before proceeding."
            )}
          </Text>
        </DialogContent>
        <DialogFooter>
          <ButtonGroup>
            <BasicButton
              size="medium"
              onPress={onClose}
              aria-label={t("Cancel button")}
              testID="cancel-disable-fallback-modal-button"
            >
              {t("Cancel")}
            </BasicButton>
            <PrimaryButton
              size="medium"
              onPress={disableFallback}
              aria-label={t("Disable fallback button")}
              testID="disable-one-id-fallback-button"
            >
              {t("Disable")}
            </PrimaryButton>
          </ButtonGroup>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
